export default {
  message: {//yinni  id   
    "strid1": "Major Tournament License Application",
    "strid2": "Email",
    "strid3": "Email Verification Code",
    "strid4": "Tournament Name",
    "strid5": "Brief Introduction about the Tournament",
    "strid6": "Start Time of the Tournament",
    "strid7": "End Time of the Tournament",
    "strid8": "The tournament is held online or offline",
    "strid9": "Online",
    "strid10": "Offline",
    "strid11": "Includes both online and offline phases",
    "strid12": "Other Contact Info",
    "strid14": "Please leave your contact information (WhatsApp/Instagram/Facebook/Email, etc.)",
    "strid16": "Your Name",
    "strid17": "Organizer",
    "strid18": "Executor",
    "strid19": "Other",
    "strid20": "Submit",
    "strid21": "Back",
    "strid23": "Send",
    "strid24": "Search",
    "strid25": "Please confirm your email address with the verification code {}",
    "strid26": "This is an automated message, please do not reply. You received this email because you submitted an application on our Third-Party Tournament application website.",
    "strid27": "Please enter the applicant's email to search",
    "strid28": "Email verification code",

    "strid29": "Please read the following Terms and Conditions",
    "strid30": "Next",
    "strid31": `I have read and agreed to the above Terms and Conditions.`,
    "strid32": "Pending",
    "strid33": "Approved",
    "strid34": "Failed",
    "strid35": "Application Date",
    "strid36": "Tournament Name",
    "strid37": "Tournament Date",
    "strid38": "Status",
    "strid39": "Your application has been successfully submitted.",
    "strid40": "You can also",
    "strid41": "Use the Tournament Tool to gather players",
    "strid42": "FAQ",
    "strid43": "Back",
    "strid44": "A verification code has been sent",
    "strid45": `FAQ
    1. Question: Do I need a license to organize a community tournament?
    Answer: Yes, you need to apply for a license to organize a community tournament. This is to ensure a better community tournament experience for you and the participants. However, if your tournament prize pool is below 5000 USD, you can automatically obtain a license after confirming that you have read the Terms and Conditions.
    
    2. Question: Is there a regulation for the prize pool for community tournaments?
    Answer: Yes, if your prize pool exceeds 5000 USD, you must submit an application on the website. Of course, you will also receive more resources, including an exclusive server with all heroes and Emblems unlocked, an official authorized logo and certification, and possible promotion on official community social media!
    
    3. Question: Can my community tournament be sponsored by sponsors?
    A: Yes, it is possible, but we have specific regulations for sponsors. Please refer to the "Terms and Conditions" for details.
    
    4. Question: If the timing of my event conflicts with a major MLBB esports event, do I still have a chance to get licensed?
    Answer: If your tournament's prize pool is below 5000 USD, we will not force you to change the timing. However, if your tournament's prize pool is higher than 5000 USD, there is indeed a risk of not obtaining the official license. We still encourage you to avoid scheduling conflicts with major MLBB esports events.
    
    5. Question: What happens if I organize a tournament without a license?
    Answer: You will risk having your community tournament terminated, which is a negative experience for both you and the participants. If your prize pool is below 5000 USD, please remember to carefully read the "Terms and Conditions". If your prize pool is higher than 5000 USD, be sure to obtain an official license before organizing the tournament.`,
    "strid46":"Major Third-Party Tournament Licensing",
    "strid47":"History",
    "strid48":"FAQ",
    "strid49":"Main Menu",
    "strid50":"Application History",
    "strid51":"Select Region",
    "strid52":"WhatsApp/Instagram/Facebook/Email, etc.",
    "strid53":"Your Role",
    "strid54":"Indonesia",
    "strid55":"Philippines",
    "strid56":"Malaysia",
    "strid57":"Brazil",
    "strid58":"Singapore",
    "strid59":"Myanmar",
    "strid60":"Cambodia",
    "strid61":"Russia and other CIS countries",
    "strid62":"Türkiye",
    "strid63":"LATAM (Spanish)",
    "strid64":"Middle East and North Africa",
    "strid65":"North America",
    "strid66":"Europe",
    "strid67":"Regional",
    "strid68":"Other",
    "strid69":`
    General Rules for Licensing Tournaments by Third Parties "Mobile Legends: Bang Bang"<br>
    
    1. Summary<br>
    
    This Permission / Authorization is used for companies / organizations / individuals (hereinafter collectively referred to as "You") planning to host and host a third party tournament "Mobile Legends: Bang Bang"; if you comply with all the provisions of this Authorization and are willing to comply with all the requirements of this Authorization, this Authorization (which is a binding legal Agreement between Moonton and you) may be used to organize and organize third party events / tournaments ("Tournaments").<br>
    
    You acknowledge and agree to:<br>
    
    1) Shanghai Moonton Technology Co., Ltd. and its affiliates (hereinafter collectively referred to as "Moonton") are the owners of the Moonton logo, trademarks, "Mobile Legends: Bang Bang" and all in-game information (including but not limited to characters, skins, music, interface, images, maps. and items, etc.) ("hereinafter collectively referred to as Moonton IP");<br>
    
    2) When you use Moonton's IP, whether used in whole or in part, you agree not to cause interference or damage to Moonton's IP in any way;<br>
    
    3) Without written permission from Moonton, you are not allowed to use Moonton IP in anything other than this Tournament, and you may not register intellectual property that is similar to or the same as Moonton IP. You must use the Moonton IP associated name as the keyword for Internet searches;<br>
    
    4) Except for the limited rights to use Moonton's IP as permitted by this Authorization, Moonton no longer grants any other rights, either express or implied.<br>
    <br>
    
    2. Special Notes<br>
    
    Authorization will only take effect when the Tournament meets the following conditions and you agree to and accept all of the terms and conditions in this Agreement.
    
    Minimum Prizepool is USD 5000 or equivallent to IDR 70,000,000 (seventy million rupiah)<br>
    
    <br>
     
    
    3. General Rules<br>
    
    3.1. Tournament Name<br>
    
    3.1.1. The word "League" or "League" may not be used in the tournament name / event name / organizer name.<br>
    
    3.1.2. You may not have the same or similar name as Moonton's official events / tournaments, including but not limited to Mobile Legends: Bang Bang Professional League (MPL), Mobile Legends: Bang Bang Development League (MDL), Mobile Legends: Bang Bang Professional League Invitational (MPLI), Mobile Legends: Bang Bang Southeast Asia Cup (MSC), Mobile Legends: Bang Bang WorldChampionship (M1, M2, M3) etc.<br>
    
    3.1.3. Words that (1) endanger national security, reveal state secrets, subvert state power, or undermine national unity; (2) endanger national honor and interests, damage public interests or spread ethnic hatred; (3) contains curses or curses, including words that have the potential to offend others, words that damage the reputation of others, words that are obscene or hateful or other disturbing words; (4) in connection with obscenity, pornography, gambling, illegal drugs, violence or criminal activity; (5) promote third party applications or games; (6) is an unlicensed name whose copyright is held by other individuals or organizations which may not be contained in the name of the Tournament;<br>
    
     
    
    3. 2. Tournament Organization<br>
    
    3.2.1. Unless you have obtained permission from Moonton, you may not join other MOBA Mobile games other than "Mobile Legends: Bang Bang" in the Tournament.<br>
    
    3.2.2. During Mobile Legends: Bang Bang Professional League and Mobile Legends: Bang Bang Development League, you cannot involve active professional teams and players to participate in any form.<br>
    
    3.2.3. Companies or organizations that provide products or services that according to Moonton are detrimental to MPL or in a competitive relationship with Mobile Legends: Bang Bang mobile games may not host the Tournament.<br>
    
    3.2.4. You must clarify that the Tournament is supported by E-project rather than claiming that the Tournament is sponsored or hosted by Moonton. The "Moonton" logo may not be displayed anywhere during the Tournament.<br>
    
    3.2.5. Under the premise of complying with all current laws and regulations (including residence requirements for qualification), if a player or team needs to pay a registration fee before participating in a Tournament, the total bonus must be greater than or equal to the total registration fee collected.<br>
    
    3.2.6. You are prohibited from submitting things that will damage the image or interests of Moonton and Mobile Legends: Bang Bang.<br>
    
    3.2.7. Tournaments must be non-official. You are responsible for any problems that arise. Moonton is not responsible.<br>
    
    3.2.8. The Tournament Schedule must avoid conflict with the schedule of any official Tournament in the host region and the schedule of any official Tournament in the territory of any participating team. If after the Tournament is approved Moonton has arranged a new official tournament in the region, you will need to change the schedule accordingly. Otherwise, Moonton will cancel the Tournament Authorization and ask to stop the Tournament.<br>
    
    3.2.9. The scale of the Tournament must be in line with the plan set by Moonton.<br>
    
    3.2.10. You must give the player a bonus or other prize as promised.<br>
    
    3.2.11. You are not permitted to broadcast the Tournament on TV.<br>
    
    3.2.12. You agree to irrevocably and permanently transfer videos or video recordings related to the Tournament to Moonton or its affiliates without receiving additional fees, and to provide Moonton or its affiliates with global rights and benefits (including but not limited to ownership and intellectual property rights, etc.) .<br>
    
    3.2.13. Moonton, as the owner of the Tournament video or video recording, can broadcast or replay the above-mentioned content, and may transfer the above rights to other third parties; Likewise, Moonton has the right to modify video content and has the right to publish it in any form or commercialization.<br>
    
    3.2.14. You warrant to Moonton that any Tournament video or video recording will not violate anyone's rights, or violate local laws and regulations, and will not contain any content that violates reputation or involves defamation.<br>
    
    3.2.15. You and the participating team may not buy or sell seats or participate in the Tournament as a franchise.<br>
    
    3.3. Income and Burden<br>
    
    3.3.1. Companies involved in the sale or promotion of the following products or services may not sponsor the Tournament:<br>
    
    -Pornography (or very adult content);<br>
    
    -Alcohol, marijuana and illegal drugs;<br>
    
    -Tobacco or its affiliates (such as PRO, Super or LA Zone, etc.);<br>
    
    -firearm;<br>
    
    -Organizations involved in gambling;<br>
    
    3.3.2 Companies or organizations that provide products or services that Moonton thinks are detrimental to MPL or in a competitive relationship with the Mobile Legends: Bang Bang mobile game.<br>
    
    3.3.3. The tournament will not involve gambling of any kind (including lottery and virtual competitive betting).<br>
    
    3.3.4. This event is not sponsored / endorsed by certain political parties, or organizations affiliated with certain political / racial / ethnic / religious interests.<br>
    
    3.3.5. This event complies with local regulations (especially with regard to health protocols).<br>
    
    
    3.3.6. If you wish to crowdfunding activities for a Tournament, you must certify that the Tournament and crowdfunding activities have nothing to do with Moonton. And the benefits accruing through crowdfunding must all be used for the Tournament. You must not save the crowdfunding results as profit.<br>
    
    3.3.7. You may not create or sell any merchandise that contains Moonton and its related brands or elements on behalf of the Tournament.<br>
    
    3.3.8. You may not use Tournament organizations and Tournament related events for profit, and you may not earn profitable income.<br>
    <br>
    
    4. Others<br>
    
    4.1. If you wish to host a Tournament under the terms of this Authorization, you must comply with all of the terms and conditions here. If you run a Tournament without obtaining Authorization, you are deemed to agree to the terms and conditions stated in this Authorization Agreement.<br>
    
    4.2. You agree that Moonton may review your books and records to ensure that you comply with the terms of this Agreement;<br>
    
    4.3. In the event of a dispute between you and Moonton, we will try to resolve the dispute through 30 days of negotiations with the parties. If negotiations fail, any dispute will be governed by Singapore law and must be submitted to the Singapore International Arbitration Center for settlement.<br>
    
    4.4. The Tournament must comply with all applicable laws and regulations, as well as the policies of other party service providers that you may use; In the event of a Tournament, including your failure to comply with the terms and conditions of this Authorization, causes a claim or lawsuit being filed by a third party, you are fully responsible and agree to compensate Moonton.<br>
    
    4.5. The Tournament Authorization Requirements only apply in the region to which you are assigned. Final interpretations of these General Rules are Moonton's. For matters not covered, the official interpretation of the Tournament will apply. Moonton reserves the right to adjust and publish the rules based on the actual situation without notifying you.<br>
    
    4.6. Moonton reserves the right to cancel the Tournament under any circumstances, and will not be responsible for your loss.`
    ,
    "strid70":"Other",
    "strid71":"A verification code has been sent to your email address {emails}. Please check.",
    "strid72":"The total prize pool of the tournament is (please convert to USD)",
    "strid73": `*No need to apply for a license based on the current prize pool. You can use the <a href="https://play.mobilelegends.com/match/#/" target="_blank">Tournament Tool</a> to create the tournament directly and it will automatically get licensed.`,
  }
}

